// extracted by mini-css-extract-plugin
module.exports = {"BackButton":"BackButton_BackButton__1Ic_c","label":"BackButton_label__2wpUR","icon":"BackButton_icon__H9tGg"};